module.exports = __webpack_public_path__ + "static/media/routebar-arrow.15f81d0f.svg";